/*
 * Swaps the collection product grid between a vendor's Parts and Equipment
 * collections without a full page load, using the Section Rendering API.
 *
 * The grid's own wrapper element is kept and only its contents are replaced:
 * main.js caches the .tab__content nodes on load, so swapping the wrapper
 * itself would break the Models/Manuals tabs.
 */
(function () {
  var tabs = document.querySelectorAll('.pne-tab');
  if (tabs.length === 0) return;

  function getGrid() {
    var results = document.getElementById('filter-results');
    return results ? results.closest('.tab__content[data-tab="1"]') : null;
  }

  function getSectionId(el) {
    var section = el.closest('[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function setActive(url) {
    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('href') === url;
      tab.classList.toggle('btn--primary', isActive);
      tab.classList.toggle('btn--secondary', !isActive);
    });
  }

  function load(url) {
    var grid = getGrid();
    var sectionId = grid ? getSectionId(grid) : null;

    // Without a grid to swap into, fall back to a normal page load.
    if (!sectionId) {
      window.location.href = url;
      return;
    }

    grid.setAttribute('aria-busy', 'true');

    var separator = url.indexOf('?') === -1 ? '?' : '&';

    fetch(url + separator + 'section_id=' + sectionId)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var incoming = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.tab__content[data-tab="1"]');

        if (!incoming) throw new Error('No product grid in response');

        grid.innerHTML = incoming.innerHTML;
        if (incoming.dataset.numResults) {
          grid.dataset.numResults = incoming.dataset.numResults;
        }

            // Lazy images render with data-src and no src, and the loader only runs
            // once on page load, so injected cards stay blank without this.
            if (typeof initLazyImages === 'function') initLazyImages();

            // Prices render at their base value until the B2B app reruns, so a
            // swapped tab would otherwise show list prices to B2B customers.
            if (typeof refreshB2BPrices === 'function') refreshB2BPrices();

        setActive(url);
        history.pushState({ pneTabs: true }, '', url);
        grid.removeAttribute('aria-busy');
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      load(tab.getAttribute('href'));
    });
  });

  // The swapped-in markup carries its own filter and pagination state, so a
  // plain reload is the reliable way back rather than replaying the swap.
  window.addEventListener('popstate', function (event) {
    if (event.state && event.state.pneTabs) window.location.reload();
  });
})();
